<template>
    <div class="choose-create-new layout-sub-page">
        <!-- 1. 顶部菜单栏 -->
        <div class="choose-create-new-title width90p">
            <div class="collate-title-bar clearfix">
                <span class="collate-title collate-title-small">{{title}}</span>
                <div class="collate-type">
                    <span v-for="(tab, index) in tabArr" v-bind:key="tab" v-bind:class="{'cur': curTabIndex == index}" @click="clickTab(index)">{{tab}}</span>
                </div>
            </div>
        </div>

        <!-- 2. 主要表单部分 -->
        <!-- 2.1 输入时间 -->
        <div v-if="curTabIndex == 0" class="width90p">
            <collate-form 
                v-bind:parentNode="parentNode" 
                v-bind:chooseGroupFunc="clickChooseGroup"
                v-bind:chooseLabelFunc="clickChooseLabel">
            </collate-form>
        </div>
        <!-- 2.2 四柱 -->
        <advanced-collate-form
            v-if="curTabIndex == 1"
            v-bind:itemSize="itemSize"
            v-bind:basicPos="basicPos"
            v-bind:chooseGroupFunc="clickChooseGroup"
            v-bind:chooseLabelFunc="clickChooseLabel">
        </advanced-collate-form>

        <div class="famous-pedia-bottom-bar dsp-flex">
            <div class="famous-pedia-btn-back" @click.passive="clickBack">返回</div>
            <div class="famous-pedia-btn-start" @click.passive="clickStart">{{btnText}}</div>
        </div>

        <!-- 5. 选择地址组件 -->
        <van-overlay v-show="showArea" @click.passive="clickShowAreaOverlay" />
        <vant-area v-show="showArea"></vant-area>

        <!-- 6. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel></input-birthday-panel>
        </van-popup>

        <!-- 7. 重复八字过滤弹框 -->
        <van-popup v-bind:value="showSamePop" class="layout-same-select-pop-box" @click-overlay="clickSameSelectOverlay">
            <vant-same-select-pop
                v-bind:popTitle="'已存在四柱相的八字，请选择从已有八字创建还是以新八字创建：'"
                v-bind:noteText="'选择已有：'"
                v-bind:buttonText="'以新八字创建'"
                v-bind:selectedList="recordSameEightWordList"
                v-bind:itemFunc="clickSameListItem"
                v-bind:saveFunc="clickSameSave">
            </vant-same-select-pop>
        </van-popup>

        <router-view></router-view>
    </div>
</template>


<script>
import AdvancedCollateForm from '../../layouts/collate/AdvancedCollateForm.vue'
import CollateForm from '../../layouts/collate/CollateForm.vue'
import InputBirthdayPanel from '../../components/InputBirthdayPanel.vue'
import VantArea from '../../layouts/vant/VantArea.vue'
import VantSameSelectPop from '../../layouts/vant/VantSameSelectPop.vue'
import { MOMENT_TIME } from '../../modules/momenttime'
export default {
    name: 'ChooseCreateNew',
    components: { AdvancedCollateForm, CollateForm, InputBirthdayPanel, VantArea, VantSameSelectPop },
    computed: {
        chooseFromPage() {
            return this.$store.state.chooserecord.chooseFromPage;
        },
        curTabIndex() {
            return this.$store.state.chooserecord.curTabIndex;
        },
        showSamePop() {
            return this.$store.state.record.showSamePop;
        },
        recordSameEightWordList() {
            return this.$store.state.record.recordSameEightWordList;
        },
        showArea() {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            curPath: '',
            title: '起盘',
            tabArr: ['输入时间', '四柱'],
            btnText: '起盘并选择此命盘',
            parentNode: {'name': 'ChooseCreateNew'},
            itemSize: {width: 0, height: 0},
            basicPos: {x: 0, y: 0},  //第一个item的值，用来计算点击item的pos值，以确定三角形的定位
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initPageData();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            this.curPath = this.$router.history.current.fullPath;

            var topDiv = document.getElementsByClassName('choose-create-new-title')[0];
            var mainDiv = document.getElementsByClassName('advanced-collate-main')[0];
            var formDiv = document.getElementsByClassName('advanced-collate-form')[0];
            var itemBoxDiv = document.getElementsByClassName('layout-asb-item')[0];
            var itemDiv = document.getElementsByClassName('layout-asb-box')[0];
            if(!itemBoxDiv || !itemDiv) { return; }
            var x = parseInt(itemBoxDiv.clientWidth / 2) - 15,
                y = topDiv.clientHeight + formDiv.clientHeight + itemDiv.clientHeight*2 + 45;
            this.$set(this.basicPos, 'x', x);
            this.$set(this.basicPos, 'y', y);
            this.$set(this.itemSize, 'width', itemBoxDiv.clientWidth);
            this.$set(this.itemSize, 'height', (itemDiv.clientHeight + 20));
            console.log('initDom----', this.basicPos.x, this.basicPos.y, this.itemSize)
        },
        initPageData() {
            if(this.chooseFromPage == 'famouspedia') {
                this.title = '创建名人百科';
                this.btnText = '起盘并创建此八字百科';
            }
        },
        clickTab(index) {
            var curIndex = this.$store.state.chooserecord.curTabIndex;
            if(index == 0 && curIndex != 0) {
                this.$store.dispatch('collate/resetData');
            }
            if(index == 1 && curIndex != 1) {
                this.$store.dispatch('collate/initSizhuCollate');
            }
            this.$store.state.chooserecord.curTabIndex = index;
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
            this.$bus.emit('resetIPBPKeyBoard');
        },
        clickChooseGroup() {
            this.$router.replace(this.curPath+'/choosegroup');
        },
        clickChooseLabel() {
            this.$router.replace(this.curPath+'/label');
        },
        clickSameSelectOverlay() {
            this.$store.state.record.showSamePop = false;
        },
        clickSameListItem(data) {
            this.$store.state.record.showSamePop = false;   
            var personInfo = this.$store.state.record.recordOriginalData[data.id];
            console.log('clickSameListItem--------', data, personInfo, this.chooseFromPage)
            if(personInfo) {
                if(this.chooseFromPage == 'discussmain') {
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$router.push({
                        path: '/discusscreate'
                    });
                }else if(this.chooseFromPage == 'famouspedia') {
                    this.addBaike(personInfo);
                }else if(this.chooseFromPage == 'marriage') {
                    this.addMarriage(personInfo);
                }
            }
        },
        clickSameSave() {
            var me = this,
                formData = this.getDefaultFormData();
            console.log('clickSameSave', formData);
            if(formData) {
                this.$store.state.record.showSamePop = false;
                if(this.chooseFromPage == 'discussmain') {
                    this.addBaziDiscuss(formData);
                }else if(this.chooseFromPage == 'famouspedia') {
                    this.addBaziBaike(formData);
                }else if(this.chooseFromPage == 'marriage') {
                    this.addMarriage(formData);
                }
            }
        },
        clickBack() {
            this.$router.go(-1);
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('chooserecord/resetData');
            this.$store.dispatch('allrecord/resetRecordData');
            this.$store.dispatch('group/resetChooseGroupData')
            this.$store.dispatch('label/resetData');
        },
        clickStart() {
            // 共用组件获取的表单数据
            var me = this,
                formData = this.getDefaultFormData();
            console.log('clickStart------', formData);
            if(formData) {
                this.$store.dispatch('record/checkRecordListSameSiZhu', {
                    formData: formData,
                    cb: function() {
                        if(me.chooseFromPage == 'discussmain') {
                            me.addBaziDiscuss(formData);
                        }else if(me.chooseFromPage == 'famouspedia') {
                            me.addBaziBaike(formData);
                        }else if(me.chooseFromPage == 'marriage') {
                            me.addMarriage(formData);
                        }
                    }
                });
            }
        },
        addBaike(personInfo) {
            var me = this;
            this.$store.dispatch('famouspedia/addBaike', {
                data: personInfo,
                cb: function() {
                    me.goToEditPage();
                }
            });
        },
        addBaziBaike(formData) {
            var me = this;
            this.$store.dispatch('famouspedia/addBaziBaike', {
                formData: formData,
                cb: function() {
                    me.goToEditPage();
                }
            });
        },
        addMarriage(formData) {
            if(typeof(formData.birthday) != 'number') {
                formData.birthdayDate = formData.birthday;
                formData.birthday = MOMENT_TIME.getUnixTimeByTimeStr(formData.birthday);
            }
            console.log('addMarriage-----', formData);
            this.$store.dispatch('marriage/confirmChooseItem', formData);
            this.$router.replace('/marriage');
        },
        goToEditPage() {
            this.$toast('创建百科草稿成功，可在[我的百科]中查看');
            var me = this;
            var curPath = this.$router.history.current.fullPath;
            setTimeout(() => {
                if(curPath.indexOf('embedded') != -1) {
                    curPath = curPath.replace('/famouspediacreate', '/famouspediaedit')
                    me.$router.replace(curPath);
                }else {
                    me.$router.replace('/famouspediaedit');
                }
            }, 100);
        },
        getDefaultFormData() {
            var formData = Object.assign({}, this.$store.state.collate.formData);
            // 处理生日时间:返回之后时间没有默认设置了,设置一个默认值；
            var starttime = formData.birthday == '' && this.curPediaCreateTabIndex == 0 ? MOMENT_TIME.getTimeStampByNow() : formData.birthday;
            if(starttime == '') {
                this.$toast('请填写生日');
                return null;
            }else {
                formData.birthday = typeof(starttime) == 'number' ? MOMENT_TIME.getFormateTimeByTimeStamp(starttime * 1000) : starttime;
            }
            // 处理姓名:可以空名起盘，生成命名取为"未命名"
            formData.f_name = formData.f_name == '' ? '未命名' : formData.f_name;
            // 处理分组:
            formData.f_group = this.$store.state.group.choosedGroup.id;
            formData.f_group = !formData.f_group || formData.f_group == '' ? 0 : formData.f_group;
            // 处理性别:
            formData.sex = formData.sex == '' ? 0 : formData.sex;
            // 处理location:
            formData.location = this.curPediaCreateTabIndex == 0 ? '' : formData.location;
            // 处理早晚子时:
            formData.zwzs = parseInt(this.settingConfigData.zaoWanZiShi);
            // 处理标签及备注信息
            formData.label = this.$store.state.label.selectedLabelId;
            formData.remark = this.$store.state.label.remarkStringData;
            return formData;
        },
        addBaziDiscuss(formData) {
            var me = this;
            this.$store.dispatch('collate/submitCollate', {
                formData: formData,
                cb: function() {
                    me.$router.push({
                        path: '/discusscreate'
                    });
                }
            })
        }
    }
}
</script>